define('core/constants/mediaTypeConstants',[
    'exports',
], function (
    exports
) {
    'use strict';

    exports.VIDEO_CODES = [
        '3',     // YOUTUBE_VIDEO
        '9',     // FACEBOOK_VIDEO
        '12',    // VIMEO_VIDEO
        '14',    // VINE_VIDEO
    ];
});

